import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'optimizeImage', standalone: true })
export class OptimizeImage implements PipeTransform {
	private width = 263 * 2
	private height = 154 * 2
	transform(
		url: string | undefined,
		output: 'jpg' | 'avif' | 'webp' = 'webp',
		width?: number,
		height?: number
	) {
		if (!url) {
			return ''
		}
		this.width = width ?? this.width
		this.height = height ?? this.height

		return `${url}?ims=${this.width}x${this.height}/filters:format(${output})`
	}
}
